import { LabelsPricingPageRecord, SiteLocale } from 'apps/website/types/dato';
import React from 'react';
import { OfferProps, PricingRangeWithDiscountAndTotalProps } from '../../types';
import BreakdownDiscountTooltip from './BreakdownDiscountTooltip';
import BreakdownTooltip from './BreakdownTooltip';

export const BreakdownTooltips = ({
  labels,
  pricesRange,
  nbEmployee,
  locale,
  offer,
}: {
  labels?: LabelsPricingPageRecord | null;
  pricesRange?: PricingRangeWithDiscountAndTotalProps | null;
  nbEmployee: number;
  locale: SiteLocale;
  offer: OfferProps;
}) => {
  const discount = pricesRange?.discountPrices?.price;
  if (offer?.isFirstPayroll) {
    return (
      <BreakdownDiscountTooltip
        labels={labels}
        pricesRange={pricesRange}
        nbEmployee={nbEmployee}
        locale={locale}
        offer={offer}
      />
    );
  }
  if (!discount) {
    return (
      <BreakdownTooltip
        labels={labels}
        pricesRange={pricesRange}
        nbEmployee={nbEmployee}
        locale={locale}
        offer={offer}
      />
    );
  }
  if (discount) {
    return (
      <BreakdownDiscountTooltip
        labels={labels}
        pricesRange={pricesRange}
        nbEmployee={nbEmployee}
        locale={locale}
        offer={offer}
      />
    );
  }
};
